module.exports = __webpack_public_path__ + "media/images/homes/EasySplit-MergeChecks-d7c460eab42b13a761c009df391b49f2.png";